import { Directive } from "@angular/core";

@Directive({
    selector: "[appHoverHighlight]",
    standalone: true,
    host: {
        "[class.hovered]": "isHovered",
        "(mouseenter)": "onMouseEnter()",
        "(mouseleave)": "onMouseLeave()",
    },
})
export class HoverHighlightDirective {
    public isHovered = false;

    public onMouseEnter() {
        this.isHovered = true;
    }
    public onMouseLeave() {
        this.isHovered = false;
    }
}
